import { Apple, Download, Smartphone } from "lucide-react";

// Android: served same-origin from /downloads/flex-office.apk, which the mobile build
// script (scripts/build-flexoffice-mobile.js) copies into public/ after every Android
// build — no external hosting needed. REACT_APP_FLEXOFFICE_ANDROID_APK_URL overrides it
// (e.g. to point at an S3/CDN copy instead).
//
// iOS: Apple doesn't allow installing a raw .ipa from a webpage. There are exactly two
// supported install paths, both of which require the IPA to be built and signed on a Mac
// with Xcode + an Apple Developer account (see docs/flex-office-mobile.md — not possible
// from this Windows toolchain):
//   1. TestFlight / App Store — REACT_APP_FLEXOFFICE_IOS_APP_URL, a plain link.
//   2. Ad-hoc OTA install — REACT_APP_FLEXOFFICE_IOS_MANIFEST_URL, an https:// URL to a
//      signed manifest.plist (template: docs/ios-manifest-template.plist) describing where
//      the signed IPA lives; this is wrapped in an itms-services:// link that iOS Safari
//      recognizes as an install trigger.
const ANDROID_APK_URL = process.env.REACT_APP_FLEXOFFICE_ANDROID_APK_URL || "/downloads/flex-office.apk";
const IOS_MANIFEST_URL = process.env.REACT_APP_FLEXOFFICE_IOS_MANIFEST_URL;
const IOS_APP_URL = IOS_MANIFEST_URL
  ? `itms-services://?action=download-manifest&url=${encodeURIComponent(IOS_MANIFEST_URL)}`
  : process.env.REACT_APP_FLEXOFFICE_IOS_APP_URL;

const DownloadCard = ({ icon: Icon, title, description, href, ctaLabel, download }) => (
  <div className="flex flex-col items-center gap-4 rounded-2xl border border-gray-200 bg-white p-8 text-center shadow-sm">
    <Icon className="h-10 w-10 text-blue-600" />
    <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
    <p className="text-sm text-gray-500">{description}</p>
    {href ? (
      <a
        href={href}
        download={download}
        className="inline-flex items-center gap-2 rounded-lg bg-blue-600 px-5 py-2.5 text-sm font-medium text-white transition hover:bg-blue-700"
      >
        <Download className="h-4 w-4" />
        {ctaLabel}
      </a>
    ) : (
      <span className="text-sm font-medium text-gray-400">Coming soon</span>
    )}
  </div>
);

const DownloadFlexOfficeApp = () => (
  <div className="mx-auto max-w-3xl px-6 py-16">
    <div className="mb-10 text-center">
      <h1 className="text-3xl font-bold text-gray-900">Get the Flex Office app</h1>
      <p className="mt-2 text-gray-500">
        Manage bookings, invoices, and your workspace on the go.
      </p>
    </div>

    <div className="grid gap-6 sm:grid-cols-2">
      <DownloadCard
        icon={Smartphone}
        title="Android"
        description="Download the APK directly, or install it from the Play Store once it's published."
        href={ANDROID_APK_URL}
        download="flex-office.apk"
        ctaLabel="Download for Android"
      />
      <DownloadCard
        icon={Apple}
        title="iOS"
        description="Install via TestFlight, or from the App Store once it's published."
        href={IOS_APP_URL}
        ctaLabel="Download for iOS"
      />
    </div>
  </div>
);

export default DownloadFlexOfficeApp;
